import { gql } from '@apollo/client'
import { BaseBlock, BlockFragment } from '../blocks.types'
import { ViewableBy } from '../utilities/viewable-check'

export const ImageBlockFragment: BlockFragment = {
  name: 'image',
  fragment: gql`
    fragment image on Image {
      id
      blockName
      blockType
      image {
        url
        alt
        width
        height
      }
      imageMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on Image {
      id
      blockName
      blockType
      image {
        url
        alt
        width
        height
      }
      imageMeta: meta {
        viewableBy
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const ImageBlockType = 'image'

export interface ImageBlock extends BaseBlock {
  blockType: typeof ImageBlockType
  imagePriority?: boolean
  image: {
    url: string
    alt: string
    width: number
    height: number
  }
  imageMeta?: {
    viewableBy: [ViewableBy]
  }
}
